// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// The theme every Vision application shares: the design tokens and the lucide icon set
// from @signifi/vision-dashboard-ui, the component defaults, and the saved (or OS) theme
// to start in, read before first paint. The preference key is the one the shell's theme
// toggle writes, so moving between applications keeps the theme.
import { visionVuetifyOptions, THEME_STORAGE_KEY } from '@signifi/vision-shell/theme'

export { THEME_STORAGE_KEY }

export default createVuetify(visionVuetifyOptions({ themeStorageKey: THEME_STORAGE_KEY }))
